import React from 'react';
import { useSelector } from 'react-redux';

const Privacy = () => {
  const language = useSelector((state) => state.language);

  return (
    <div className={`min-h-screen bg-gradient-to-br from-white via-blue-50 to-indigo-50 py-20 px-4`} dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="container mx-auto max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          {language === "ar" ? "سياسة الخصوصية" : language === "fr" ? "Politique de confidentialité" : "Privacy Policy"}
        </h1>

        <div className="bg-white rounded-xl shadow-lg p-8 space-y-6 text-gray-700">
          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "مقدمة" : language === "fr" ? "Introduction" : "Introduction"}
            </h2>
            <p className="leading-relaxed">
              {language === "ar"
                ? "نحن في RAQIB نلتزم بحماية خصوصيتك. تصف هذه السياسة كيفية نجمع ونستخدم ونحمي معلوماتك الشخصية."
                : language === "fr"
                ? "Chez RAQIB, nous nous engageons à protéger votre vie privée. Cette politique décrit comment nous collectons, utilisons et protégeons vos informations personnelles."
                : "At RAQIB, we are committed to protecting your privacy. This policy describes how we collect, use, and protect your personal information."}
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "المعلومات التي نجمعها" : language === "fr" ? "Informations que nous collectons" : "Information We Collect"}
            </h2>
            <p className="leading-relaxed mb-3">
              {language === "ar" ? "قد نجمع المعلومات التالية:" : language === "fr" ? "Nous pouvons collecter les informations suivantes:" : "We may collect the following information:"}
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>{language === "ar" ? "معلومات الاتصال والملف الشخصي" : language === "fr" ? "Informations de contact et de profil" : "Contact and profile information"}</li>
              <li>{language === "ar" ? "معلومات الدفع والفواتير" : language === "fr" ? "Informations de paiement et de facturation" : "Payment and billing information"}</li>
              <li>{language === "ar" ? "بيانات الاستخدام والسجلات" : language === "fr" ? "Données d'utilisation et journaux" : "Usage data and logs"}</li>
              <li>{language === "ar" ? "معلومات الأمان والتحضير" : language === "fr" ? "Informations de sécurité" : "Security information"}</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "كيف نستخدم معلوماتك" : language === "fr" ? "Comment nous utilisons vos informations" : "How We Use Your Information"}
            </h2>
            <p className="leading-relaxed">
              {language === "ar"
                ? "نستخدم المعلومات المجمعة لتقديم خدماتنا وتحسينها والامتثال لالتزاماتنا القانونية وحماية حقوقك."
                : language === "fr"
                ? "Nous utilisons les informations collectées pour fournir et améliorer nos services et nous conformer à nos obligations légales."
                : "We use the information collected to provide and improve our services and comply with our legal obligations."}
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "حماية البيانات" : language === "fr" ? "Protection des données" : "Data Protection"}
            </h2>
            <p className="leading-relaxed">
              {language === "ar"
                ? "نحن نستخدم معايير الصناعة وتقنيات التشفير لحماية بياناتك من الوصول والاستخدام غير المصرح به."
                : language === "fr"
                ? "Nous utilisons les normes de l'industrie et les techniques de chiffrement pour protéger vos données contre l'accès et l'utilisation non autorisés."
                : "We use industry-standard encryption and security measures to protect your data from unauthorized access."}
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "حقوقك" : language === "fr" ? "Vos droits" : "Your Rights"}
            </h2>
            <p className="leading-relaxed mb-3">
              {language === "ar"
                ? "لديك الحق في:"
                : language === "fr"
                ? "Vous avez le droit de:"
                : "You have the right to:"}
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>{language === "ar" ? "الوصول إلى بياناتك الشخصية" : language === "fr" ? "Accéder à vos données personnelles" : "Access your personal data"}</li>
              <li>{language === "ar" ? "تصحيح المعلومات غير الدقيقة" : language === "fr" ? "Corriger les informations inexactes" : "Correct inaccurate information"}</li>
              <li>{language === "ar" ? "حذف بياناتك" : language === "fr" ? "Supprimer vos données" : "Delete your data"}</li>
              <li>{language === "ar" ? "سحب الموافقة" : language === "fr" ? "Retirer votre consentement" : "Withdraw consent"}</li>
            </ul>
          </div>

          <div className="bg-teal-50 border-l-4 border-teal-500 p-4 rounded">
            <p className="text-sm text-gray-700">
              {language === "ar"
                ? "آخر تحديث لهذه السياسة: مارس 2026. إذا كان لديك أي أسئلة حول سياسة الخصوصية هذه، يرجى التواصل معنا على privacy@raqibapp.com"
                : language === "fr"
                ? "Dernière mise à jour de cette politique: mars 2026. Si vous avez des questions sur cette politique de confidentialité, veuillez nous contacter à privacy@raqibapp.com"
                : "Last updated: March 2026. If you have any questions about this privacy policy, please contact us at privacy@raqibapp.com"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
